import React from 'react';
import { cn } from '../../lib/utils';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}
export function Card({
  className,
  children,
  ...props
}: CardProps) {
  return <div className={cn('bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden', className)} {...props} data-id="element-309">
      {children}
    </div>;
}